module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"manage_shipping":"Manage Shipping","ship_parcel":"Ship parcel"},"id":{"manage_shipping":"Kelola Pengiriman","ship_parcel":"Kirim Paket"}}')
  delete Component.options._Ctor
}
